import React from 'react';
import { ShapeTile } from './ShapeBrowser';
import { ExpandIcon, MoreIcon, SearchIcon } from './sidebarIcons';

// The collapsed sidebar: expand, jump to search, the recent shapes, and "more" (expands).
const CollapsedStrip = ({ recent, dragProps, onExpand, onSearch }) => (
    <div className="shape-strip">
        <button type="button" className="sidebar-strip-button" aria-label="Expand sidebar" onClick={onExpand}>
            <ExpandIcon />
        </button>
        <button type="button" className="sidebar-strip-button is-search" aria-label="Search shapes" onClick={onSearch}>
            <SearchIcon size={20} />
        </button>
        <span className="shape-strip-divider" />
        {recent.map((shape) => (
            <ShapeTile key={shape.name} shape={shape} dragProps={dragProps} className="shape-tile shape-tile--strip" />
        ))}
        <button type="button" className="sidebar-strip-button is-more" aria-label="More shapes" onClick={onExpand}>
            <MoreIcon />
        </button>
    </div>
);

export default CollapsedStrip;
